"use client";

import { createContext, useCallback, useContext, useRef } from "react";

type MobileMenuDrawerContextType = {
  openDrawer: () => void;
  registerDrawer: (openFn: () => void) => void;
};

const MobileMenuDrawerContext = createContext<MobileMenuDrawerContextType>({
  openDrawer: () => {},
  registerDrawer: () => {},
});

export function MobileMenuDrawerContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const drawerOpenRef = useRef<(() => void) | null>(null);

  const registerDrawer = useCallback((openFn: () => void) => {
    drawerOpenRef.current = openFn;
  }, []);

  const openDrawer = useCallback(() => {
    drawerOpenRef.current?.();
  }, []);

  return (
    <MobileMenuDrawerContext.Provider value={{ openDrawer, registerDrawer }}>
      {children}
    </MobileMenuDrawerContext.Provider>
  );
}

export const useMobileMenuDrawer = () => {
  return useContext(MobileMenuDrawerContext);
};
